import RestoreFromTrashIcon from "@mui/icons-material/RestoreFromTrash";
import React from "react";
import { AppButton, IAppButtonProps } from "ui/Scripts/source/components/framework/Button/AppButton";

export const RestoreFromTrashBinButton = (props: IAppButtonProps) => (
    <AppButton
        variant="text"
        color="success"
        startIcon={<RestoreFromTrashIcon />}
        {...props}>
        {props.children}
    </AppButton>
);
